import {
  EllipsisIcon,
  Flex,
  MailIcon,
  Text,
  ThGhostIcon,
} from '@buffer-mono/popcorn'

import { LinkifiedText } from '~publish/legacy/shared-components/LinkifiedText'
import { parseThreadsLinks } from '~publish/legacy/utils/channels/threads/helpers'

import { SpeechBubble } from './SpeechBubble'
import { LikeIcon } from '../../../../assets/threads'
import type { ProfilePreview, ThreadsContent } from '../../../types'
import { getScheduledTimeLabel } from '../../getScheduledTimeLabel'

import styles from './ThreadGhostPost.module.css'

import type { JSX } from 'react'

export const ThreadGhostPost = ({
  content,
  profile,
}: {
  content: ThreadsContent
  profile: ProfilePreview
}): JSX.Element => {
  const { text, scheduledAt } = content
  const { avatar, username, displayName, timezone } = profile

  const usernameToDisplay = displayName || username
  const scheduledTimeLabel = getScheduledTimeLabel(scheduledAt, timezone)

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.avatarWrapper}>
          <img
            className={styles.avatar}
            alt={`${usernameToDisplay}'s avatar`}
            data-testid="avatar"
            src={avatar}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.header}>
            <span className={styles.username} translate="no">
              {usernameToDisplay}
            </span>
            {scheduledTimeLabel && (
              <div className={styles.ago} data-testid="scheduled-time">
                {scheduledTimeLabel}
              </div>
            )}
            <EllipsisIcon className={styles.menuIcon} />
          </div>

          {text ? (
            <SpeechBubble>
              <LinkifiedText
                links={parseThreadsLinks(text, false)}
                whitespace="pre-wrap"
                className={styles.text}
              >
                {text}
              </LinkifiedText>
            </SpeechBubble>
          ) : (
            <div className={styles.emptyText} />
          )}

          <Flex gap="lg" align="center" className={styles.actions}>
            <LikeIcon size="small" color="currentColor" />
            <MailIcon size="small" color="currentColor" />
            <Flex gap="2xs" align="center">
              <ThGhostIcon size="small" color="currentColor" />
              <Text size="sm">24h left</Text>
            </Flex>
          </Flex>
        </div>
      </div>
    </>
  )
}
